/* eslint-disable camelcase */
import React from 'react';

import { StyledPagination } from './PaginationStyles';

const Pagination = (previousButton, nextButton) => (
  <StyledPagination>
    {nextButton} {previousButton}
  </StyledPagination>
);

export default Pagination;
